<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4lyp2a/tc-custom/9781504062749.jpg?1728259407933" alt="This image is the cover for the book Forest Lord, The Fane Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forest Lord, The Fane Series
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times</i>–bestselling author “takes readers to a realm where Faerie and mortal worlds intersect and spins a darkly magical story” (<i>Library Journal</i>).</b><br/>  <br/> After eloping with her mysterious cousin Cornelius, Eden Fleming discovers he is, in reality, a powerful, otherworldly being, a guardian of the forest, and she was “given” to him by her father in a bargain for the latter’s life. Though her feelings for the forest lord are real, Eden flees—only to learn she is pregnant with his halfling child.<br/>  <br/> Years later, following a loveless marriage, Eden returns to the dilapidated estate where she last saw Cornelius. And when he finds her there, a devastating lie will be exposed—one that will reveal Cornelius’s true heart, heal Eden’s shattered soul, and save the magical realm they have both come to love.<br/>  <br/> Based on the ancient English legend of Herne the Hunter, <i>The Forest Lord</i> is “sheer magic . . . utterly romantic and impossible to put down” (Mary Balogh).<br/>  <br/> “Magical, mystical, and moving, Krinard’s book has a surprise villain and a nice twist at the end. Fans of Nora Roberts’ Irish trilogy [<i>Jewels of the Sun</i>, <i>Tears of the Moon</i>, <i>Heart of the Sea</i>] and Karen Fox’s <i>Buttercup Baby</i> will be delighted by this fantasy and its underlying ecological message.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Krinard
      </h2>
      
      <p class="authorDescription body article">Susan Krinard is a bestselling author of futuristic and paranormal romance novels. She has won a RITA Award for Best Contemporary Fantasy; <I>Affaire de Coeur</I>&rsquo;s award for Best Up-and-Coming Author of Futuristic, Fantasy, and Paranormal Romance; and the PRISM Award for Best Dark Paranormal and Best Short Fiction for her novella &ldquo;Kinsman&rdquo; in the bestselling anthology <I>Out of This World</I>. Her romance <I>Lord of the Beasts</I> hit #33 on the <I>New York Times</I> bestseller list. Most recently, Krinard has published the Nightsiders paranormal romance series with Harlequin Nocturne and the Midgard urban fantasy series with Tor Books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ddde446e